import { render, staticRenderFns } from "./SiteMap.vue?vue&type=template&id=63803628&scoped=true&"
import script from "./SiteMap.vue?vue&type=script&lang=ts&"
export * from "./SiteMap.vue?vue&type=script&lang=ts&"
import style0 from "./SiteMap.vue?vue&type=style&index=0&id=63803628&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63803628",
  null
  
)

export default component.exports